import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "../../common/_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "../../common/interopRequireDefault-d2c9da36.js";
import {_ as _extends_1, o as objectWithoutPropertiesLoose} from "../../common/defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "../../common/index-877ea290.js";
import {r as require$$3} from "../../common/clsx.m-5dc7436b.js";
import {c as core} from "../../common/index-0a000c27.js";
import {s as styled_1, u as useThemeProps_1} from "../../common/useThemeProps-ef190a94.js";
import {a as Input, F as FilledInput, O as OutlinedInput, S as Select} from "../../common/index-fbdf124d.js";
import {I as InputLabel} from "../../common/index-d8d53549.js";
import {F as FormControl} from "../../common/index-7c8cd0e6.js";
import {F as FormHelperText} from "../../common/index-b2b0c568.js";
import _jsxRuntime from "react/jsx-runtime";
import "../../common/capitalize-c580b26a.js";
import "../../common/hoist-non-react-statics.cjs-7c8198a1.js";
import "../../common/colorManipulator-ba921df7.js";
import "../../common/useForkRef-edb3fede.js";
import "../../common/emotion-element-99289b21.browser.esm-15d91a3a.js";
import "../../common/useTheme-81ac7d8e.js";
import "../../common/useEventCallback-4c5b62b3.js";
import "../../common/nested-5a43708e.js";
import "../../common/ModalUnstyled-c2fd569c.js";
import "../../common/Portal-3c4bf8a9.js";
import "react-dom";
import "../../common/Popper-131a89f2.js";
import "../../common/index-e5ee6fc8.js";
import "../../common/index-c5dee027.js";
import "../../common/ListContext-0f0f18c4.js";
import "../../common/useForkRef-b591be37.js";
import "../../common/useEnhancedEffect-d69b40f2.js";
import "../../common/capitalize-0607751a.js";
import "../../common/Menu-d373436d.js";
import "../../common/index-ea610a7a.js";
import "../../common/useTheme-ad5c2c5a.js";
import "../../common/index-1947ef0f.js";
import "../../common/index-639d8dc8.js";
import "../../common/Transition-8cd86cbd.js";
import "../../common/utils-70a9ce59.js";
import "../../common/index-b7ea6358.js";
import "../../common/index-58b58757.js";
import "../../common/utils-cdef6dcd.js";
import "../../common/useControlled-c12dd7f0.js";
import "../../common/formControlState-63450f78.js";
import "../../common/useFormControl-9e2a3560.js";
import "../../common/ArrowDropDown-4d05c1b7.js";
import "../../common/createSvgIcon-ee034812.js";
import "../../common/index-2dbc6c5e.js";
import "../../common/isMuiElement-5f955b12.js";
var textFieldClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getTextFieldUtilityClass = getTextFieldUtilityClass;
  function getTextFieldUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiTextField", slot);
  }
  const textFieldClasses = (0, core.generateUtilityClasses)("MuiTextField", ["root"]);
  var _default = textFieldClasses;
  exports.default = _default;
});
var TextField_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _extends2 = interopRequireDefault(_extends_1);
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _styled = interopRequireDefault(styled_1);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _Input = interopRequireDefault(Input);
  var _FilledInput = interopRequireDefault(FilledInput);
  var _OutlinedInput = interopRequireDefault(OutlinedInput);
  var _InputLabel = interopRequireDefault(InputLabel);
  var _FormControl = interopRequireDefault(FormControl);
  var _FormHelperText = interopRequireDefault(FormHelperText);
  var _Select = interopRequireDefault(Select);
  const _excluded = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const variantComponent = {
    standard: _Input.default,
    filled: _FilledInput.default,
    outlined: _OutlinedInput.default
  };
  const useUtilityClasses = (ownerState) => {
    const {
      classes
    } = ownerState;
    const slots = {
      root: ["root"]
    };
    return (0, core.unstable_composeClasses)(slots, textFieldClasses_1.getTextFieldUtilityClass, classes);
  };
  const TextFieldRoot = (0, _styled.default)(_FormControl.default, {
    name: "MuiTextField",
    slot: "Root",
    overridesResolver: (props, styles) => styles.root
  })({});
  const TextField2 = /* @__PURE__ */ React$1.forwardRef(function TextField3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiTextField"
    });
    const {
      autoComplete,
      autoFocus = false,
      children,
      className,
      color = "primary",
      defaultValue,
      disabled = false,
      error = false,
      FormHelperTextProps,
      fullWidth = false,
      helperText,
      id,
      InputLabelProps,
      inputProps,
      InputProps,
      inputRef,
      label,
      maxRows,
      minRows,
      multiline = false,
      name,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      required = false,
      rows,
      select = false,
      SelectProps,
      type,
      value,
      variant = "outlined"
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const ownerState = (0, _extends2.default)({}, props, {
      autoFocus,
      color,
      disabled,
      error,
      fullWidth,
      multiline,
      required,
      select,
      variant
    });
    const classes = useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === "outlined") {
      if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") {
        InputMore.notched = InputLabelProps.shrink;
      }
      if (label) {
        var _InputLabelProps$requ;
        const displayRequired = (_InputLabelProps$requ = InputLabelProps == null ? void 0 : InputLabelProps.required) != null ? _InputLabelProps$requ : required;
        InputMore.label = /* @__PURE__ */ (0, _jsxRuntime.jsxs)(React$1.Fragment, {
          children: [label, displayRequired && " *"]
        });
      }
    }
    if (select) {
      if (!SelectProps || !SelectProps.native) {
        InputMore.id = void 0;
      }
      InputMore["aria-describedby"] = void 0;
    }
    const helperTextId = helperText && id ? `${id}-helper-text` : void 0;
    const inputLabelId = label && id ? `${id}-label` : void 0;
    const InputComponent = variantComponent[variant];
    const InputElement = /* @__PURE__ */ (0, _jsxRuntime.jsx)(InputComponent, (0, _extends2.default)({
      "aria-describedby": helperTextId,
      autoComplete,
      autoFocus,
      defaultValue,
      fullWidth,
      multiline,
      name,
      rows,
      maxRows,
      minRows,
      type,
      value,
      id,
      inputRef,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      inputProps
    }, InputMore, InputProps));
    return /* @__PURE__ */ (0, _jsxRuntime.jsxs)(TextFieldRoot, (0, _extends2.default)({
      className: (0, _clsx.default)(classes.root, className),
      disabled,
      error,
      fullWidth,
      ref,
      required,
      color,
      variant,
      ownerState
    }, other, {
      children: [label && /* @__PURE__ */ (0, _jsxRuntime.jsx)(_InputLabel.default, (0, _extends2.default)({
        htmlFor: id,
        id: inputLabelId
      }, InputLabelProps, {
        children: label
      })), select ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(_Select.default, (0, _extends2.default)({
        "aria-describedby": helperTextId,
        id,
        labelId: inputLabelId,
        value,
        input: InputElement
      }, SelectProps, {
        children
      })) : InputElement, helperText && /* @__PURE__ */ (0, _jsxRuntime.jsx)(_FormHelperText.default, (0, _extends2.default)({
        id: helperTextId
      }, FormHelperTextProps, {
        children: helperText
      }))]
    }));
  });
  var _default = TextField2;
  exports.default = _default;
});
var TextField = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    textFieldClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _TextField.default;
    }
  });
  Object.defineProperty(exports, "textFieldClasses", {
    enumerable: true,
    get: function() {
      return _textFieldClasses.default;
    }
  });
  var _TextField = interopRequireDefault(TextField_1);
  var _textFieldClasses = _interopRequireWildcard(textFieldClasses_1);
  Object.keys(_textFieldClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _textFieldClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _textFieldClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(TextField);
export default __pika_web_default_export_for_treeshaking__;
